var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
        's-align-5', 's-marker', ("m-" + _vm.getOneWordForMarker), 
        { 'sm-finished' : !_vm.marker.length }
    ],style:({
        height: _vm.size + 'px', width: _vm.size + 'px',
        'background-color': _vm.color && _vm.color.length ? _vm.color : ''
    })},[(!_vm.marker.length && !_vm.deadMarker.length)?[_c('warning-icon',{staticClass:"i-white",attrs:{"size":"16"}})]:[_vm._v("\n        "+_vm._s(_vm.abr)+"\n    ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }